// Mapping of law names, topics, and categories to Compliance Hub and companion site articles
// Companion sites: pii.compliancehub.wiki | biometric.myprivacy.blog | privacyrights.compliancehub.wiki

export const lawReferences = {
  // ── Federal Laws ────────────────────────────────────────────────
  "COPPA": {
    title: "COPPA Compliance Guide",
    url: "https://www.compliancehub.wiki/childrens-online-privacy-protection-act-coppa-a-comprehensive-guide/",
    description: "Comprehensive guide to COPPA requirements and compliance"
  },
  "COPPA 2.0": {
    title: "COPPA 2.0 & Child Safety Bills",
    url: "https://www.compliancehub.wiki/in-addition-to-coppa-and-kosa-for-child-safety-bills/",
    description: "Updates to COPPA and emerging child safety legislation"
  },
  "KOSA": {
    title: "KOSA (Kids Online Safety Act)",
    url: "https://www.compliancehub.wiki/kids-online-safety-act-s-1409-protecting-our-children-in-the-digital-age/",
    description: "Complete guide to the Kids Online Safety Act"
  },

  // ── California Laws ──────────────────────────────────────────────
  "California AB 56": {
    title: "California AB 56 - Mental Health Warnings",
    url: "https://www.compliancehub.wiki/californias-tech-surveillance-laws-what-compliance-teams-need-to-know-about-ab-56-sb-243-and-ab-1043/",
    description: "California's tech surveillance laws including AB 56 mental health warnings"
  },
  "California AB 1043": {
    title: "California Digital Age Assurance Act (AB 1043)",
    url: "https://www.compliancehub.wiki/californias-tech-surveillance-laws-what-compliance-teams-need-to-know-about-ab-56-sb-243-and-ab-1043/",
    description: "California's app store age verification requirements"
  },

  // ── Texas Laws ───────────────────────────────────────────────────
  "Texas SB 2420": {
    title: "Texas App Store Accountability Law (SB 2420)",
    url: "https://www.compliancehub.wiki/texas-sb2420-complete-compliance-guide-for-app-stores-and-developers/",
    description: "Complete compliance guide for Texas app store requirements"
  },
  "Texas SCOPE": {
    title: "Texas SCOPE Act & Privacy Laws",
    url: "https://www.compliancehub.wiki/texas-app-store-age-verification-law-faces-legal-challenges-what-compliance-teams-need-to-know/",
    description: "Texas age verification and privacy requirements"
  },

  // ── Age Verification ─────────────────────────────────────────────
  "Age Verification": {
    title: "Age Verification Compliance Guide",
    url: "https://www.compliancehub.wiki/the-age-verification-compliance-nightmare-how-businesses-can-navigate-americas-patchwork-of-conflicting-state-laws/",
    description: "Navigating America's patchwork of age verification laws"
  },
  "Age Verification Technology": {
    title: "Age Verification Technology & Implementation",
    url: "https://www.compliancehub.wiki/google-adds-age-check-tech-as-texas-utah-and-louisiana-enforce-digital-id-laws/",
    description: "How tech companies are implementing age verification"
  },

  // ── General Child Safety ─────────────────────────────────────────
  "Child Safety Legislation": {
    title: "Global Child Safety Legislation Wave",
    url: "https://www.compliancehub.wiki/global-child-safety-legislation-wave-july-august-2025-compliance-guide/",
    description: "2025 compliance guide for global child safety laws"
  },

  // ── International Laws ───────────────────────────────────────────
  "Australia Social Media": {
    title: "Australia's Social Media Minimum Age Ban",
    url: "https://www.compliancehub.wiki/australias-groundbreaking-esafety-laws-a-comprehensive-analysis-of-the-social-media-minimum-age-ban/",
    description: "Comprehensive analysis of the world's first under-16 social media ban with $49.5M penalties"
  },
  "Australia Bold Experiment": {
    title: "Australia's Bold Experiment: Under-16 Social Media Ban",
    url: "https://www.compliancehub.wiki/australias-bold-experiment-the-worlds-first-under-16-social-media-ban/",
    description: "In-depth look at Australia's pioneering social media age restriction legislation"
  },
  "UK Online Safety Act": {
    title: "UK Online Safety Act & EU DSA: Cross-Border Impact",
    url: "https://www.compliancehub.wiki/digital-compliance-alert-uk-online-safety-act-and-eu-digital-services-act-cross-border-impact-analysis/",
    description: "Cross-border compliance analysis of UK's Online Safety Act age verification requirements"
  },
  "EU Digital Services Act": {
    title: "The EU Digital Services Act: New Era of Online Regulation",
    url: "https://www.compliancehub.wiki/the-eus-digital-services-act-a-new-era-of-online-regulation/",
    description: "Foundational guide to the DSA framework for protecting minors online"
  },
  "GDPR Children": {
    title: "CCPA, GDPR, and LGPD Compliance Compared",
    url: "https://www.compliancehub.wiki/privacy-laws-compared-ccpa-gdpr-and-lgpd-compliance-requirements-2025-update/",
    description: "GDPR compliance guide including children's data protection requirements"
  },
  "International Child Privacy": {
    title: "Global Children's Privacy Laws Comparison",
    url: "https://www.compliancehub.wiki/global-child-safety-legislation-wave-july-august-2025-compliance-guide/",
    description: "Comparative guide to international children's privacy regulations"
  },

  // ── PII Companion Site ───────────────────────────────────────────
  "PII Guide": {
    title: "PII Classification & Data Inventory Guide",
    url: "https://pii.compliancehub.wiki/",
    description: "What counts as personally identifiable information under COPPA, CCPA, GDPR, and state laws — full classification guide"
  },
  "PII Children": {
    title: "Children's PII: What Data You Can and Cannot Collect",
    url: "https://pii.compliancehub.wiki/",
    description: "How children's privacy laws define and restrict PII collection from minors"
  },

  // ── Biometric Companion Site ─────────────────────────────────────
  "Biometric Laws": {
    title: "Biometric Privacy Laws Tracker",
    url: "https://biometric.myprivacy.blog/",
    description: "State & federal biometric data laws — BIPA, Texas CUBI, COPPA 2026 biometric rules, and more"
  },
  "Biometric Age Verification": {
    title: "Biometric Age Verification: Privacy & Legal Requirements",
    url: "https://biometric.myprivacy.blog/",
    description: "When age verification uses facial estimation or biometric ID — compliance obligations by state"
  },
  "Biometric COPPA": {
    title: "COPPA 2026 & Biometric Data: New Requirements",
    url: "https://biometric.myprivacy.blog/",
    description: "FTC COPPA 2026 amendments added biometric identifiers as personal information — what changes"
  },

  // ── Consumer Privacy Rights Companion Site ───────────────────────
  "Privacy Rights": {
    title: "US Consumer Privacy Rights — State-by-State Guide",
    url: "https://privacyrights.compliancehub.wiki/",
    description: "Your privacy rights under CCPA, state comprehensive privacy laws, and children's protections — interactive guide"
  },
  "Privacy Rights Minors": {
    title: "Minors' Privacy Rights Under US State Laws",
    url: "https://privacyrights.compliancehub.wiki/",
    description: "How children's and teens' privacy rights differ from adult rights across US states"
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// getReferencesForLaw — returns contextual references for a given law modal
// ─────────────────────────────────────────────────────────────────────────────
export function getReferencesForLaw(lawName, category) {
  const refs = [];
  const add = (key) => {
    const ref = lawReferences[key];
    if (ref && !refs.find(r => r.url === ref.url)) refs.push(ref);
  };

  // ── Federal law matches ─────────────────────────────────────
  if (lawName.includes("COPPA") && !lawName.includes("2.0")) add("COPPA");
  if (lawName.includes("COPPA 2.0")) add("COPPA 2.0");
  if (lawName.includes("KOSA") || lawName.includes("Kids Online Safety")) add("KOSA");

  // COPPA 2026 amendments added biometrics — cross-link biometric guide
  if (lawName.includes("COPPA") || lawName.includes("FTC")) {
    add("Biometric COPPA");
    add("PII Children");
    add("Privacy Rights Minors");
  }

  // ── California ──────────────────────────────────────────────
  if (lawName.includes("AB 56") || lawName.includes("Mental Health Warning")) add("California AB 56");
  if (lawName.includes("AB 1043") || lawName.includes("Digital Age Assurance")) add("California AB 1043");
  if (lawName.includes("CCPA") || lawName.includes("California Consumer Privacy")) {
    add("PII Guide");
    add("Privacy Rights");
  }

  // ── Texas ───────────────────────────────────────────────────
  if (lawName.includes("SB 2420") || (lawName.includes("Texas") && lawName.includes("App Store"))) add("Texas SB 2420");
  if (lawName.includes("SCOPE")) add("Texas SCOPE");

  // ── Age Verification (any state) ────────────────────────────
  if (category === "Age Verification") {
    add("Age Verification");
    add("Biometric Age Verification");  // many AV methods use biometrics
    add("Privacy Rights");
  }

  // ── AADC laws ───────────────────────────────────────────────
  if (category === "AADC" || lawName.includes("Age-Appropriate Design") || lawName.includes("AADC")) {
    add("PII Guide");
    add("Biometric Laws");
    add("Privacy Rights Minors");
  }

  // ── Consumer Privacy laws ────────────────────────────────────
  if (category === "Consumer Privacy") {
    add("PII Children");
    add("Privacy Rights Minors");
    add("Biometric Laws");
  }

  // ── App Store laws ───────────────────────────────────────────
  if (category === "App Store") {
    add("PII Guide");
    add("Privacy Rights");
  }

  // ── Social Media laws ────────────────────────────────────────
  if (category === "Social Media") {
    add("Privacy Rights Minors");
    add("PII Children");
  }

  // ── AI Chatbot laws ──────────────────────────────────────────
  if (category === "AI Chatbot") {
    add("PII Children");
    add("Biometric Laws");
    add("Privacy Rights Minors");
  }

  // ── Federal laws (general) ───────────────────────────────────
  if (category === "Federal") {
    add("PII Guide");
    add("Biometric Laws");
    add("Privacy Rights");
  }

  // ── International ────────────────────────────────────────────
  if (lawName.includes("Australia") || lawName.includes("Social Media Minimum Age")) {
    add("Australia Social Media");
    add("Australia Bold Experiment");
  }
  if (lawName.includes("UK") || lawName.includes("Online Safety Act") || lawName.includes("United Kingdom")) {
    add("UK Online Safety Act");
  }
  if (lawName.includes("Digital Services Act") || lawName.includes("DSA") || lawName.includes("European Union")) {
    add("EU Digital Services Act");
  }
  if (lawName.includes("GDPR") || lawName.includes("LGPD") || lawName.includes("Brazil")) {
    add("GDPR Children");
    add("PII Guide");
  }
  if (category === "Comprehensive") {
    add("Child Safety Legislation");
    add("Privacy Rights");
  }

  // ── Fallback ─────────────────────────────────────────────────
  if (refs.length === 0) {
    add("International Child Privacy");
    add("PII Guide");
    add("Privacy Rights");
  }

  return refs.slice(0, 4); // cap at 4 to keep modal clean
}

// Get all unique references for the Resources section
export function getAllReferences() {
  return Object.values(lawReferences);
}
